import { useEffect, useMemo, useRef } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css"; // Styles du WYSIWYG
import { markdownToHtml } from "../utils/markdownToHtml";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }], // 🎨 Color picker
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
  ],
};

type Props = {
  value: string;
  onChange: (newValue: string) => void;
  readOnly?: boolean;
};

const readOnlyModules = { toolbar: false };

export default function Editor(props: Props) {
  const convertedHtml = useMemo(() => {
    return markdownToHtml(props.value);
  }, [props.value]);

  const lastNotifiedRef = useRef<string | null>(null);

  useEffect(() => {
    // If incoming value was markdown and was converted to HTML, synchronize parent form
    if (convertedHtml !== props.value && props.value !== '' && lastNotifiedRef.current !== convertedHtml) {
      lastNotifiedRef.current = convertedHtml;
      props.onChange(convertedHtml);
    }
  }, [convertedHtml, props.value, props.onChange]);

  return (
    // Quill reads modules once at mount: remount when switching to read-only
    <ReactQuill
      key={props.readOnly ? 'read-only' : 'editable'}
      theme="snow"
      value={convertedHtml}
      onChange={props.onChange}
      modules={props.readOnly ? readOnlyModules : modules}
      readOnly={props.readOnly}
    />
  );
}